import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Device, DeviceStatus, DeviceType, WeldType, WeldTypeNames } from '../../types/device';
import {
  Server, Clock, Activity, Search, Settings, Link2, Box, Check,
  X, XCircle, CheckCircle, RefreshCw, AlertCircle, HelpCircle, Cog, Bell, ArrowLeft,
  Layers, Hash, Calendar,
} from 'lucide-react';
import { CollapsibleFilterBar } from '../../../project/components/dashboard/materials/tabs/Filters/CollapsibleFilterBar';
import { fetchDevices, bulkUpdateDevices, updateDeviceProject } from '../../../../redux/device/actions';
import { fetchProjectList } from '../../../../redux/Project/action';
import { assignProjecttoDevice, updateDeviceStatus } from '../../../../redux/device/saga';
import { Checkbox } from '../../../../components/ui/checkbox';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '../../../../components/ui/select';
import { Input } from '../../../../components/ui/input';
import { Button } from '../../../../components/ui/button';
import { Label } from '../../../../components/ui/label';
import EdgeDeviceManagement from './EdgeDeviceManagement_restructured';
import DeviceSettingsModal from './DeviceSettingsModal';
import { StatusUpdateDialog } from './StatusUpdateDialog';
import { formatDate, formatDateUTC, formatDateLocal } from '../../../../utils/unitUtils';
import { Card, CardContent } from '../../../../components/ui/card';
import { Dialog, DialogContent, DialogContentWithoutClose, DialogTitle, DialogFooter, DialogDescription, DialogHeader } from '../../../../components/ui/dialog';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../../components/ui/table';
import { SearchableSelect } from '../../../../components/ui/SearchableSelect';
import { useDeviceManagement } from '../../hooks/useDeviceManagement';
// import { deviceApi } from '../../../../redux/device/saga';
// const statusColors: Record<any, string> = {
//   Pending: 'bg-red-500 ',
//   Failed: 'bg-red-500',
//   CertificateAvailable: 'bg-yellow-500',
//   DownloadComplete: 'bg-green-500',
//   Deregistered: 'bg-gray-500',
//   AdminApprovalPending: 'bg-yellow-500',
//   AdminApproved: "bg-green-500",
//   AdminRejected: 'bg-gray-500', // Changed to match Deregistered since both are "Decommissioned"
//   Register: 'bg-amber-500',
//   PublishReady: 'bg-orange-500',
// };

const statusBadgeColors: Record<any, string> = {
  Pending: 'text-readable-red bg-[rgba(196,0,31,0.06)]',
  Failed: 'text-readable-red bg-[rgba(196,0,31,0.06)]',
  CertificateAvailable: 'text-[#B38600] bg-[rgba(230,161,0,0.08)]',
  DownloadComplete: 'text-galvanizing-green bg-[rgba(31,154,58,0.08)]',
  Deregistered: 'bg-page-bg text-heritage-grey border border-[#E2E5EA]',
  AdminApprovalPending: 'text-[#B38600] bg-[rgba(230,161,0,0.08)]',
  AdminApproved: "text-galvanizing-green bg-[rgba(31,154,58,0.08)]",
  AdminRejected: 'bg-page-bg text-heritage-grey border border-[#E2E5EA]',
  Register: 'text-[#B38600] bg-[rgba(230,161,0,0.08)]',
  PublishReady: 'text-galvanizing-green bg-[rgba(31,154,58,0.08)]',
  AdminApproval: 'text-blueprint-blue bg-[rgba(0,39,63,0.06)]',
};

const userStatusMap: Record<
  string,
  { label: string; color: string; backends: string[]; icon: any; description: string }
> = {

  Approved: {
    label: "Registered",
    color: "text-galvanizing-green",
    backends: ["AdminApproved", "DownloadComplete"],
    icon: Server,
    description: "Device has been registered and ready to assing to project.",
  },
  DeviceActive: {
    label: "Active",
    color: "text-galvanizing-green",
    backends: ["PublishReady"],
    icon: CheckCircle,
    description: "Devices have been assigned to project and are fully active.",
  },
  Pending: {
    label: "Registration Pending",
    color: "text-[#B38600]",
    backends: ["Pending", "AdminApprovalPending", 'Register', "CertificateAvailable", 'Failed'],
    icon: Clock,
    description: "Devices are awaiting registration.",
  },
  AdminApproval: {
    label: "Admin Approval",
    color: "text-blueprint-blue",
    backends: ["AdminApproval"],
    icon: RefreshCw,
    description: "Devices are awaiting admin approval.",
  },


  // Failed: {
  //   label: "Registration Failed",
  //   color: "text-red-600",
  //   backends: ['Failed'],
  //   icon: AlertCircle,
  //   description: "Registration process failed — action may be required from admin.",
  // },
  Decommissioned: {
    label: "Decommissioned",
    color: "text-heritage-grey",
    backends: ["Deregistered", "AdminRejected"],
    icon: XCircle,
    description: "Devices are de-activated",
  },
  // ReRegister: {
  //   label: "Re-registration Available",
  //   color: "text-blue-600",
  //   backends: ["Register"],
  //   icon: RefreshCw,
  //   description: "Devices can be re-registered by the user.",
  // },

};
// const backendToUserStatus: Record<string, string> = {
//   Pending: "Pending",
//   AdminApprovalPending: "Pending",
//   AdminApproved: "Approved",
//   CertificateAvailable: "Approved",
//   DownloadComplete: "Approved",
//   PublishReady: "Approved",
//   AdminRejected: "Decommissioned",
//   Deregistered: "Decommissioned",
//   Failed: "Failed",
//   Register: "ReRegister",
// };



const deviceStatusName: Record<any, string> = {

  Pending: 'Registration Pending',
  Failed: 'Registration Failed',
  CertificateAvailable: 'Certificate Available',
  DownloadComplete: 'Certificate Installed',
  Deregistered: 'Decommissioned',
  AdminApprovalPending: 'Awaiting Admin Approval',
  AdminApproved: "Approved",
  AdminRejected: 'Decommissioned',
  Register: 'Enable Re-registration',
  PublishReady: 'Commissioned',

};
const statusName: Record<any, string> = {

  Pending: 'Registration Pending',
  Failed: 'Registration Failed',
  CertificateAvailable: 'Registration Pending',
  DownloadComplete: 'Registered',
  Deregistered: 'Decommissioned',
  AdminAprovel: 'Awaiting Admin Approval',
  AdminApprovalPending: 'Awaiting Admin Approval',
  AdminApproved: "Approved",
  AdminRejected: 'Decommissioned',
  Register: 'Enable Re-registration',
  PublishReady: 'Active',
  AdminApproval: 'Admin Approval',
  // Add any other statuses that might appear
  connected: 'Connected',
  disconnected: 'Disconnected',
  communicating: 'Communicating',
  online: 'Online',
  offline: 'Offline',
  error: 'Error',
  failed: 'Failed',
  success: 'Success',
  timeout: 'Timeout',
  'in progress': 'In Progress'
};

const DeviceManagement: React.FC = () => {
  const dispatch = useDispatch();
  const deviceState = useSelector((state: any) => state.deviceData);
  const projectState = useSelector((state: any) => state.project);
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const userEmail = (user && user.email) ? user.email : '';
  const projects = projectState?.ProjectList || [];
  const isProjectListLoading = projectState?.isProjectListLoading || false;

  // Use the custom hook for device management
  const {
    devices,
    loading: devicesLoading,
    error: devicesError,
    lastFetchTime,
    isManualRefresh,
    manualRefresh,
    startAutoRefresh,
    stopAutoRefresh
  } = useDeviceManagement();



  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState<DeviceStatus | 'all'>('all');
  const [typeFilter, setTypeFilter] = useState<DeviceType | 'all'>('all');
  const [weldTypeFilter, setWeldTypeFilter] = useState<WeldType | 'all'>('all');
  const [communicationStatusFilter, setCommunicationStatusFilter] = useState<'all' | 'Online' | 'Offline'>('all');
  const [selectedDevices, setSelectedDevices] = useState<string[]>([]);
  const [bulkStatus, setBulkStatus] = useState<DeviceStatus | ''>('');
  const [bulkProject, setBulkProject] = useState('');
  const [selectedDevice, setSelectedDevice] = useState<Device | null>(null);
  const [isDeviceManagementOpen, setIsDeviceManagementOpen] = useState(false);
  const [selectedStatusCard, setSelectedStatusCard] = useState<string | null>(null);
  const [isBulkUpdating, setIsBulkUpdating] = useState(false);
  const [isProjectAssigning, setIsProjectAssigning] = useState(false);
  const [isStatusUpdateModalOpen, setIsStatusUpdateModalOpen] = useState(false);
  const [selectedStatusForUpdate, setSelectedStatusForUpdate] = useState<DeviceStatus | null>(null);
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
  const [selectedProjectName, setSelectedProjectName] = useState<string>('');
  const [initialLoad, setInitialLoad] = useState(true);
  const [isProjectAssignDialogOpen, setIsProjectAssignDialogOpen] = useState(false);
  const [singleAssignDevice, setSingleAssignDevice] = useState<Device | null>(null);
  const [singleAssignProjectName, setSingleAssignProjectName] = useState<string>('');
  const [isSingleAssigning, setIsSingleAssigning] = useState(false);
  const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);
  const [isAcknowledgeAlarmsModalOpen, setIsAcknowledgeAlarmsModalOpen] = useState(false);
  const [notAcknowledgedEvents, setNotAcknowledgedEvents] = useState<Record<string, unknown>[]>([]);
  const [loadingNotAcknowledged, setLoadingNotAcknowledged] = useState(false);
  const [acknowledgingEventId, setAcknowledgingEventId] = useState<number | null>(null);
  const [selectedCategoryType, setSelectedCategoryType] = useState<string>('');
  // Load projects on component mount
  useEffect(() => {
    dispatch(fetchProjectList({}));
  }, [dispatch]);

  // Ensure devices is an array
  const devicesArray = Array.isArray(devices) ? devices : [];

  const fetchNotAcknowledgedEvents = React.useCallback(() => {
    const apiUrl = process.env.REACT_APP_LIMITS_API_BASE_URL || 'http://localhost:9000';
    const endpoint = `${apiUrl}/alarm-config/events/not-acknowledged`;
    setLoadingNotAcknowledged(true);
    fetch(endpoint, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error(`HTTP ${res.status}`))))
      .then((data) => {
        const inner = data?.data;
        const list = Array.isArray(inner?.data)
          ? inner.data
          : Array.isArray(data?.data)
            ? data.data
            : Array.isArray(data?.events)
              ? data.events
              : Array.isArray(data?.results)
                ? data.results
                : Array.isArray(data)
                  ? data
                  : [];
        setNotAcknowledgedEvents(
          list.map((item: unknown) =>
            typeof item === 'object' && item !== null ? (item as Record<string, unknown>) : {}
          )
        );
      })
      .catch(() => setNotAcknowledgedEvents([]))
      .finally(() => setLoadingNotAcknowledged(false));
  }, []);

  // Fetch not-acknowledged every time /admin/devices is called (initial load, Refresh, auto-refresh)
  useEffect(() => {
    if (lastFetchTime == null) return;
    fetchNotAcknowledgedEvents();
  }, [lastFetchTime, fetchNotAcknowledgedEvents]);

  // Refetch when opening the modal so the table has latest data
  useEffect(() => {
    if (!isAcknowledgeAlarmsModalOpen) return;
    fetchNotAcknowledgedEvents();
  }, [isAcknowledgeAlarmsModalOpen, fetchNotAcknowledgedEvents]);

  const handleAcknowledgeEvent = React.useCallback(
    async (eventId: number | string) => {
      const id = Number(eventId);
      if (Number.isNaN(id)) return;
      const apiUrl = process.env.REACT_APP_LIMITS_API_BASE_URL || 'http://localhost:9000';
      const endpoint = `${apiUrl}/alarm-config/acknowledge/${id}`;
      setAcknowledgingEventId(id);
      try {
        const body: { acknowledged_by?: string } = {};
        if (userEmail) body.acknowledged_by = userEmail;
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        fetchNotAcknowledgedEvents();
      } catch (error) {
        console.error('Failed to acknowledge event:', error);
      } finally {
        setAcknowledgingEventId(null);
      }
    },
    [fetchNotAcknowledgedEvents, userEmail]
  );

  // Update selectedDevice with latest data when devices are refreshed
  useEffect(() => {
    if (selectedDevice && devicesArray.length > 0 && !devicesLoading) {
     
      // Find the updated device by ID
      const updatedDevice = devicesArray.find((d: Device) => d.id === selectedDevice.id);
      if (updatedDevice) {
        setSelectedDevice(updatedDevice);
        
      //   // Check if key properties have changed to avoid unnecessary updates
      //   const hasChanged = 
      //     updatedDevice.communication_status !== selectedDevice.communication_status ||
      //     updatedDevice.status !== selectedDevice.status ||
      //     updatedDevice.metadata?.firmware !== selectedDevice.metadata?.firmware ||
      //     updatedDevice.deviceData !== selectedDevice.deviceData;
        
      //   if (hasChanged) {
      //     // Update selectedDevice with latest data
          
       }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [devicesArray]); // Update when devices array changes or loading completes

  // // Debug logging



  // Get projects from Redux store
  const availableProjects = Array.isArray(projects) ? projects.map((project: any) => {
    // Handle multiple possible ID field names
    const projectId = project.projectId || project.id || project.project_id || null;
    
    return {
      id: projectId,
      name: project.projectName || project.name || project.project_name,
      projectNumber: project.projectNumber || project.project_number
    };
  }).filter((p: any) => p.id != null) : []; // Filter out projects without IDs

  // Extract unique statuses from devices
  const availableStatuses = Array.from(
    new Set(devicesArray.map((d: Device) => d.status))
  ).sort();

  // Extract unique types from devices
  const availableTypes = Array.from(
    new Set(devicesArray.map((d: Device) => d.type))
  ).sort();

  // Extract unique weld types from devices
  const availableWeldTypes = Array.from(
    new Set(
      devicesArray
        .map((d: Device) => d.metadata.weldType)
        .filter((weldType: string | undefined): weldType is string =>
          weldType !== undefined && weldType.trim() !== ''
        )
    )
  ).sort();

  const filteredDevices = devicesArray.filter((device: Device) => {
    const matchesSearch = device.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      device.id.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === 'all' || device.status === statusFilter;
    const matchesType = typeFilter === 'all' || device.type === typeFilter;
    const matchesWeldType = weldTypeFilter === 'all' || device.metadata.weldType === weldTypeFilter;
    const matchesCommunicationStatus = communicationStatusFilter === 'all' || device.communication_status === communicationStatusFilter;

    // Apply status card filter
    let matchesStatusCard = true;
    if (selectedStatusCard) {
      const statusConfig = userStatusMap[selectedStatusCard];
      if (statusConfig) {
        matchesStatusCard = statusConfig.backends.includes(device.status as DeviceStatus);
        // When a status card is active, show both online and offline devices
      }
    }

    return matchesSearch && matchesStatus && matchesType && matchesWeldType && matchesCommunicationStatus && matchesStatusCard;
  });

  // Active filter count — only counts filters living *inside* the CollapsibleFilterBar.
  // Status (strip) and Online/Offline (strip) are visible-on-screen, so excluded here to avoid double-signalling.
  const activeFilterCount =
    (statusFilter !== 'all' ? 1 : 0) +
    (weldTypeFilter !== 'all' ? 1 : 0);

  // Clear filters living inside CollapsibleFilterBar. Strip filters (status, online/offline)
  // self-clear by clicking the active chip again.
  const handleClearFilters = () => {
    setSearchTerm('');
    setStatusFilter('all');
    setWeldTypeFilter('all');
  };

  // Handle status card click
  const handleStatusCardClick = (cardKey: string) => {
    if (cardKey === 'total') {
      // Total card - show all devices
      setSelectedStatusCard(null);
    } else if (selectedStatusCard === cardKey) {
      // If clicking the same card, clear the filter (show all)
      setSelectedStatusCard(null);
    } else {
      // Select the new card
      setSelectedStatusCard(cardKey);
    }
  };

  const handleDeviceSelect = (deviceId: string) => {
    setSelectedDevices(prev =>
      prev.includes(deviceId)
        ? prev.filter(id => id !== deviceId)
        : [...prev, deviceId]
    );
  };

  // const handleSelectAll = () => {
  //   if (selectedDevices.length === filteredDevices.length) {
  //     setSelectedDevices([]);
  //   } else {
  //     setSelectedDevices(filteredDevices.map((d: Device) => d.id));
  //   }
  // };

  const handleBulkStatusUpdate = async () => {
    if (!bulkStatus || selectedDevices.length === 0) return;

    setIsBulkUpdating(true);
    try {
      const payload = {
        deviceIds: selectedDevices,
        status: bulkStatus,
      };

      dispatch(bulkUpdateDevices(payload));

      setSelectedDevices([]);
      setBulkStatus('');
    } catch (error) {
      console.error('Failed to update device status', error);
    } finally {
      setIsBulkUpdating(false);
    }
  };

  const handleOpenProjectAssignDialog = () => {
    if (!selectedProjectName || selectedDevices.length === 0) return;
    setIsProjectAssignDialogOpen(true);
  };

  const handleSingleAssign = async () => {
    if (!singleAssignDevice || !singleAssignProjectName) return;
    const targetProject = availableProjects.find((p: any) => p.name === singleAssignProjectName);
    if (!targetProject || !targetProject.id) {
      console.error('Target project not found or missing id:', singleAssignProjectName);
      return;
    }

    setIsSingleAssigning(true);
    try {
      await assignProjecttoDevice({
        deviceIds: [singleAssignDevice.id],
        projectNumber: (targetProject as any).projectNumber,
        projectId: targetProject.id,
        projectName: targetProject.name,
        assignedBy: userEmail,
      });
      dispatch(fetchDevices({}));
      setSingleAssignDevice(null);
      setSingleAssignProjectName('');
    } catch (error) {
      console.error('Failed to assign project to device', error);
    } finally {
      setIsSingleAssigning(false);
    }
  };

  const handleBulkProjectAssign = async () => {
    if (!selectedProjectName || selectedDevices.length === 0) return;
    const targetProject = availableProjects.find((p: any) => p.name === selectedProjectName);
    if (!targetProject) {
      console.error('Target project not found for name:', selectedProjectName);
      return;
    }
    if (!targetProject.id) {
      console.error('Target project has no ID:', targetProject);
      return;
    }

    setIsProjectAssignDialogOpen(false);
    setIsProjectAssigning(true);
    try {
      const payload = {
        deviceIds: selectedDevices,
        projectNumber: (targetProject as any).projectNumber,
        projectId: targetProject.id,
        projectName: targetProject.name
      };
    //  console.log('payload', payload);
      //dispatch(updateDeviceProject(payload));
      await assignProjecttoDevice(payload);
      dispatch(fetchDevices({}));

      setSelectedDevices([]);
      setSelectedProjectName('');
    } catch (error) {
      console.error('Failed to assign project to devices', error);
    } finally {
      setIsProjectAssigning(false);
    }
  };

  const handleAddNewProject = () => {
    // TODO: Implement add new project functionality
    console.log('Add new project clicked');
  };

  const handleSelectAllProjects = () => {
    if (selectedDevices.length === 0) return;

    // Select all available projects for bulk assignment
    const allProjectNames = availableProjects.map((project: any) => project.name);
    if (allProjectNames.length > 0) {
      setSelectedProjectName(allProjectNames[0]); // Select first project as default
    }
  };

  const handleStatusUpdate = async () => {
    if (!selectedDevice || !selectedStatusForUpdate) return;

    setIsUpdatingStatus(true);
    try {
      const payload = {
        deviceId: selectedDevice.id,
        status: selectedStatusForUpdate,
      };

      await updateDeviceStatus(payload);
      await dispatch(fetchDevices({}));
      setIsStatusUpdateModalOpen(false);
      setSelectedStatusForUpdate(null);

    } catch (error) {
      console.error('Failed to update device status', error);
    } finally {
      setIsUpdatingStatus(false);
      setIsDeviceManagementOpen(false)

    }
  };

  const getStatusBadge = (status: DeviceStatus) => (
    <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border ${statusBadgeColors[status]}`}>
      {statusName[status] || status.charAt(0).toUpperCase() + status.slice(1)}
    </span>
  );

  // Show loading state
  if (devicesLoading) {
    return (
      <div className="p-6 w-full flex items-center justify-center min-h-[700px] whitespace-nowrap gap-2 items-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-hero-red whitespace-nowrap">
        </div>
        <span className="text-text-grey text-lg">Loading devices...</span>
      </div>
    );
  }

  // Show error state
  if (devicesError) {
    return (
      <div className="p-6 w-full flex items-center justify-center">
        <div className="text-lg text-readable-red">Error loading devices: {devicesError}</div>
      </div>
    );
  }

  // console.log('device.metadata.coating_type', devices)


  return (
    <div className="p-2 w-full">

      {/* Header with stats */}
      {!isDeviceManagementOpen && (
        <div>
          {/* Status strip + toolbar — pill filters, online/offline, last-updated, refresh */}
          {(() => {
            // Devices in scope of the currently selected status pill (or all if none selected)
            const statusScopedDevices = selectedStatusCard
              ? devicesArray.filter((d: Device) => {
                  const cfg = userStatusMap[selectedStatusCard];
                  return cfg ? cfg.backends.includes(d.status as DeviceStatus) : true;
                })
              : devicesArray;
            const onlineCount = statusScopedDevices.filter((d: Device) => d.communication_status === 'Online').length;
            const offlineCount = statusScopedDevices.filter((d: Device) => d.communication_status === 'Offline').length;

            return (
              <div className="flex flex-wrap items-center gap-2 mb-6">
                <button
                  type="button"
                  onClick={() => handleStatusCardClick('total')}
                  className={`flex items-center gap-1.5 px-3 h-8 rounded-full border text-[12px] font-medium transition-colors ${
                    selectedStatusCard === null
                      ? 'bg-[rgba(0,39,63,0.06)] border-blueprint-blue text-blueprint-blue'
                      : 'bg-white border-[#E2E5EA] text-text-grey hover:bg-page-bg'
                  }`}
                >
                  Total <span className="font-semibold">{devicesArray.length}</span>
                </button>

                {Object.entries(userStatusMap).map(([key, { label, backends, description }]) => {
                  const count = devicesArray.filter((d: Device) =>
                    backends.includes(d.status as DeviceStatus)
                  ).length;
                  const active = selectedStatusCard === key;
                  return (
                    <button
                      key={key}
                      type="button"
                      title={description}
                      onClick={() => handleStatusCardClick(key)}
                      className={`flex items-center gap-1.5 px-3 h-8 rounded-full border text-[12px] font-medium transition-colors ${
                        active
                          ? 'bg-[rgba(0,39,63,0.06)] border-blueprint-blue text-blueprint-blue'
                          : 'bg-white border-[#E2E5EA] text-text-grey hover:bg-page-bg'
                      }`}
                    >
                      {label} <span className="font-semibold">{count}</span>
                    </button>
                  );
                })}

                {/* Right cluster: online/offline + last-updated + refresh */}
                <div className="ml-auto flex items-center gap-2">
                  <button
                    type="button"
                    onClick={() => setCommunicationStatusFilter(communicationStatusFilter === 'Online' ? 'all' : 'Online')}
                    className={`flex items-center gap-1.5 px-3 h-8 rounded-full border text-[12px] font-medium transition-colors ${
                      communicationStatusFilter === 'Online'
                        ? 'bg-[rgba(31,154,58,0.08)] border-galvanizing-green text-galvanizing-green'
                        : 'bg-white border-[#E2E5EA] text-text-grey hover:bg-page-bg'
                    }`}
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-hero-red"></span>
                    Online <span className="font-semibold">{onlineCount}</span>
                  </button>
                  <button
                    type="button"
                    onClick={() => setCommunicationStatusFilter(communicationStatusFilter === 'Offline' ? 'all' : 'Offline')}
                    className={`flex items-center gap-1.5 px-3 h-8 rounded-full border text-[12px] font-medium transition-colors ${
                      communicationStatusFilter === 'Offline'
                        ? 'bg-[rgba(235,28,55,0.06)] border-hero-red text-hero-red'
                        : 'bg-white border-[#E2E5EA] text-text-grey hover:bg-page-bg'
                    }`}
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-hero-red"></span>
                    Offline <span className="font-semibold">{offlineCount}</span>
                  </button>

                  <span className="ml-2 text-[12px] text-heritage-grey">
                    {lastFetchTime && `Last updated: ${formatDateUTC(lastFetchTime.toISOString())}`}
                  </span>
                  <button
                    type="button"
                    onClick={manualRefresh}
                    disabled={isManualRefresh}
                    title="Refresh"
                    aria-label="Refresh"
                    className="flex items-center justify-center w-8 h-8 rounded-lg border border-[#E2E5EA] bg-white hover:bg-page-bg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <RefreshCw size={14} className={`text-blueprint-blue ${isManualRefresh ? 'animate-spin' : ''}`} />
                  </button>
                  <button
                    type="button"
                    onClick={() => setIsSettingsModalOpen(true)}
                    title="Settings"
                    aria-label="Settings"
                    className="flex items-center justify-center w-8 h-8 rounded-lg border border-[#E2E5EA] bg-white hover:bg-page-bg transition-colors"
                  >
                    <Settings size={14} className="text-blueprint-blue" />
                  </button>
                  <button
                    type="button"
                    onClick={() => setIsAcknowledgeAlarmsModalOpen(true)}
                    title="Acknowledge alarms"
                    aria-label="Acknowledge alarms"
                    className="relative flex items-center justify-center w-8 h-8 rounded-lg border border-[#E2E5EA] bg-white hover:bg-page-bg transition-colors"
                  >
                    <Bell size={14} className="text-blueprint-blue" />
                    {loadingNotAcknowledged ? (
                      <span className="absolute -right-1 -top-1 h-3 w-3 rounded-full bg-[#E2E5EA] animate-pulse" aria-hidden />
                    ) : notAcknowledgedEvents.length > 0 ? (
                      <span className="absolute -right-1.5 -top-1.5 inline-flex min-w-[18px] h-[18px] items-center justify-center rounded-full bg-hero-red px-1 text-[10px] font-semibold text-white">
                        {notAcknowledgedEvents.length}
                      </span>
                    ) : null}
                  </button>
                </div>
              </div>
            );
          })()}

          {/* Filters and Bulk Actions */}
          <div className="mb-6">
            <CollapsibleFilterBar
              searchQuery={searchTerm}
              onSearchChange={setSearchTerm}
              searchPlaceholder="Search devices..."
              activeFilterCount={activeFilterCount}
              filteredCount={filteredDevices.length}
              filteredCountLabel="devices"
              onResetFilters={handleClearFilters}
            >
              <Select value={statusFilter} onValueChange={(value) => setStatusFilter(value as DeviceStatus | 'all')}>
                <SelectTrigger>
                  <SelectValue placeholder="All Statuses" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">
                    <div className="flex items-center gap-2">
                      <Activity className="h-4 w-4 text-heritage-grey" />
                      All Statuses
                    </div>
                  </SelectItem>
                  {availableStatuses.map((status) => {
                    const statusConfig = Object.values(userStatusMap).find(config =>
                      config.backends.includes(status as DeviceStatus)
                    );
                    const Icon = statusConfig?.icon || AlertCircle;
                    const color = statusConfig?.color || "text-heritage-grey";

                    return (
                      <SelectItem key={status} value={status}>
                        <div className="flex items-center gap-2">
                          <Icon className={`h-4 w-4 ${color}`} />
                          {statusName[status] || status.charAt(0).toUpperCase() + status.slice(1)}
                        </div>
                      </SelectItem>
                    );
                  })}
                </SelectContent>
              </Select>

              {availableWeldTypes.length > 0 && (
                <Select value={weldTypeFilter} onValueChange={(value) => setWeldTypeFilter(value as WeldType | 'all')}>
                  <SelectTrigger>
                    <SelectValue placeholder="Machine Type" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">All Machine Types</SelectItem>
                    {availableWeldTypes.map((weldType) => (
                      <SelectItem key={weldType} value={weldType}>
                        {WeldTypeNames[weldType as keyof typeof WeldTypeNames] || weldType.charAt(0).toUpperCase() + weldType.slice(1)}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              )}

            </CollapsibleFilterBar>

            {/* Bulk Actions with smooth transition */}
            <div className={`mt-4 transition-all duration-200 ease-in-out ${selectedDevices.length > 0 ? 'opacity-100 max-h-96' : 'opacity-0 max-h-0 overflow-hidden'}`}>
              <div className="flex flex-col gap-4 p-4 bg-page-bg border border-[#E2E5EA] rounded-lg">
                <div className="flex items-center gap-2">
                  <span className="text-[13px] text-text-grey">{selectedDevices.length} devices selected</span>
                </div>

                <div className="flex  gap-4">
                  {/* Status Update */}
                  {/* <div className="flex items-center gap-2">
                    <Select
                      value={bulkStatus || 'status_placeholder'}
                      onValueChange={(value) => {
                        if (value !== 'status_placeholder') {
                          setBulkStatus(value as DeviceStatus);
                        }
                      }}
                    >
                      <SelectTrigger className="w-[200px]">
                        <SelectValue placeholder="Change Status To..." />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="status_placeholder">
                          <div className="flex items-center gap-2">
                            <Settings className="h-4 w-4 text-gray-500" />
                            Change Status To...
                          </div>
                        </SelectItem>
                        {availableStatuses.map((status) => {
                          const statusConfig = Object.values(userStatusMap).find(config =>
                            config.backends.includes(status as DeviceStatus)
                          );
                          const Icon = statusConfig?.icon || AlertCircle;
                          const color = statusConfig?.color || "text-gray-500";

                          return (
                            <SelectItem key={status} value={status}>
                              <div className="flex items-center gap-2">
                                <Icon className={`h-4 w-4 ${color}`} />
                                {statusName[status] || status.charAt(0).toUpperCase() + status.slice(1)}
                              </div>
                            </SelectItem>
                          );
                        })}
                      </SelectContent>
                    </Select>
                    <Button
                      onClick={handleBulkStatusUpdate}
                      disabled={!bulkStatus || isBulkUpdating}
                      variant="default"
                    >
                      {isBulkUpdating ? (
                        <div className="flex items-center gap-2">
                          <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                          Updating...
                        </div>
                      ) : (
                        'Update Status'
                      )}
                    </Button>
                  </div> */}

                  {/* Project Assignment */}
                  <div className="flex items-center gap-2">
                    <SearchableSelect
                      value={selectedProjectName}
                      onValueChange={setSelectedProjectName}
                      placeholder="Assign to Project..."
                      searchPlaceholder="Search projects..."
                      options={availableProjects.map((project: any) => ({
                        id: project.id,
                        name: project.name
                      }))}
                      showAddButton={false}
                      disabled={isProjectAssigning || isProjectListLoading}
                      loading={isProjectAssigning || isProjectListLoading}
                      loadingText={isProjectListLoading ? "Loading projects..." : "Assigning..."}
                      className="w-[400px]"
                    />
                    {/* <Button
                      onClick={handleSelectAllProjects}
                      variant="outline"
                      size="sm"
                      disabled={isProjectAssigning || isProjectListLoading || availableProjects.length === 0}
                      className="whitespace-nowrap"
                    >
                      Select All Projects
                    </Button> */}
                    <Button
                      onClick={handleOpenProjectAssignDialog}
                      disabled={!selectedProjectName || selectedDevices.length === 0 || isProjectAssigning}
                      variant="default"
                    >
                      Assign Project
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Select All */}
          {/* <div className="flex items-center gap-2 mb-4">
            <div className="flex items-center space-x-2">
              <Checkbox
                id="select-all-devices"
                checked={selectedDevices.length === filteredDevices.length && filteredDevices.length > 0}
                onCheckedChange={handleSelectAll}
              />
              <label
                htmlFor="select-all-devices"
                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                Select All
              </label>
            </div>
          </div> */}

          {/* Device List */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {filteredDevices.map((device: Device) => (
              <div key={device.id} className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow flex flex-col h-full relative">
                {/* Checkbox for selection */}
                <div className="absolute top-4 left-4">
                  <div className="flex items-center space-x-2">
                    <Checkbox
                      id={`select-device-${device.id}`}
                      checked={selectedDevices.includes(device.id)}
                      onCheckedChange={() => handleDeviceSelect(device.id)}
                    />
                  </div>
                </div>

                <div className="p-4 flex-grow">
                  <div className="flex items-center justify-between mb-4 pl-8">
                    <h3 className="text-xs font-mono font-bold text-blueprint-blue break-all max-w-[70%]">{device.id}</h3>
                    {getStatusBadge(device.status)}
                  </div>

                  <div className="space-y-2 text-sm">

                    {device.connectedEquipment && (
                      <div className="flex items-center gap-2">
                        <Link2 className="h-4 w-4 text-heritage-grey" />
                        <span className="text-heritage-grey">Serial:</span>
                        <span className="text-text-grey font-medium">{device.connectedEquipment.serialNumber}</span>
                        <span className="text-heritage-grey">|</span>
                        <span className="text-heritage-grey">Firmware:</span>
                        <span className="text-text-grey font-medium">v1.0.0</span>
                      </div>
                    )}
                    <div className="flex items-center gap-2">
                      <Box className="h-4 w-4 text-heritage-grey" />
                      <span className="text-heritage-grey">Project:</span>
                      {device.project ? (
                        <span className="text-text-grey font-medium">{device.project.name}</span>
                      ) : (
                        <span className="text-heritage-grey italic">Unassigned</span>
                      )}
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSingleAssignDevice(device);
                          setSingleAssignProjectName(device.project?.name || '');
                        }}
                        className="ml-auto text-[12px] font-medium text-blueprint-blue hover:underline"
                      >
                        {device.project ? 'Change' : '+ Assign'}
                      </button>
                    </div>
                    {device.project && (
                      <div className="flex items-center gap-2">
                        <Box className="h-4 w-4 text-heritage-grey" />
                        <span className="text-heritage-grey">Project No.:</span>
                        <span className="text-text-grey font-medium">{device.project.projectNumber}</span>
                      </div>
                    )}

                    <div className="flex items-center gap-2">
                      <Server className="h-4 w-4 text-heritage-grey" />
                      <span className="text-heritage-grey">Machine Type:</span>
                      <span className="text-text-grey font-medium">{WeldTypeNames[device.metadata.weldType as keyof typeof WeldTypeNames] || device.metadata.weldType || (device.deviceData?.process_type ==='coating' ? device.deviceData?.coating_type : '-') || '-'}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Clock className="h-4 w-4 text-heritage-grey" />
                      <span className="text-heritage-grey">Last seen:</span>
                      <span className="text-text-grey font-medium">{formatDateUTC(device.lastSeen)}</span>
                    </div>
                  </div>
                </div>

                <div className="bg-page-bg border-t border-[#E2E5EA] px-4 py-3 rounded-b-lg mt-auto">
                  <div className="flex items-center justify-between text-sm">
                    {/* Communication Status Indicator */}
                    <div className="flex items-center gap-2">
                      <div className={`w-2 h-2 rounded-full ${device.communication_status === 'Online'
                          ? 'bg-hero-red'
                          : 'bg-hero-red'
                        }`}></div>
                      <span className={`text-xs font-medium ${device.communication_status === 'Online'
                          ? 'text-galvanizing-green'
                          : 'text-readable-red'
                        }`}>
                        {device.communication_status || 'Unknown'}
                      </span>
                    </div>

                    {/* Manage Button - Only show for online devices */}
                     
                   {   device.status === 'PublishReady' ? (
                        <Button
                          size="sm"
                          className="flex items-center gap-2 min-w-[140px] justify-center"
                          onClick={() => {
                            setSelectedDevice(device)
                            setIsDeviceManagementOpen(true)
                          }}
                        >
                          <Cog className="h-4 w-4" />
                          Manage
                        </Button>
                      ) :
                      <Button
                      //  className="flex items-center gap-2 min-w-[140px] justify-center"
                      variant="outline"
                        onClick={() => {
                          setSelectedDevice(device)
                          setIsStatusUpdateModalOpen(true)
                        }}
                      >
                        <Cog className="h-4 w-4" />
                        Register
                      </Button>
                    
                      }

                  </div>
                </div>
              </div>
            ))}
          </div>


        </div>
      )}
      {/* Status Update Dialog */}
      <StatusUpdateDialog
        isOpen={isStatusUpdateModalOpen}
        onClose={() => {
          setIsStatusUpdateModalOpen(false);
          setSelectedStatusForUpdate(null);
        }}
        selectedDevice={selectedDevice}
        selectedStatusForUpdate={selectedStatusForUpdate}
        setSelectedStatusForUpdate={setSelectedStatusForUpdate}
        onStatusUpdate={handleStatusUpdate}
        isUpdatingStatus={isUpdatingStatus}
        availableStatuses={availableStatuses}
      />

      {/* Single-device project assignment dialog */}
      <Dialog open={singleAssignDevice !== null} onOpenChange={(open) => { if (!open) setSingleAssignDevice(null); }}>
        <DialogContent className="max-w-md p-6">
          <div className="flex items-center gap-3 mb-2">
            <div className="flex-shrink-0 w-10 h-10 bg-[rgba(0,39,63,0.06)] rounded-full flex items-center justify-center">
              <Box className="h-5 w-5 text-blueprint-blue" />
            </div>
            <DialogTitle className="text-[18px] font-semibold text-blueprint-blue leading-tight">
              {singleAssignDevice?.project ? 'Change project' : 'Assign project'}
            </DialogTitle>
          </div>
          <DialogDescription className="text-[13px] text-text-grey">
            Device <span className="font-mono font-medium text-blueprint-blue">{singleAssignDevice?.id}</span>
          </DialogDescription>

          <div className="py-4">
            <SearchableSelect
              value={singleAssignProjectName}
              onValueChange={setSingleAssignProjectName}
              placeholder="Select project..."
              searchPlaceholder="Search projects..."
              options={availableProjects.map((project: any) => ({
                id: project.id,
                name: project.name,
              }))}
              showAddButton={false}
              disabled={isSingleAssigning || isProjectListLoading}
              loading={isSingleAssigning || isProjectListLoading}
              loadingText={isProjectListLoading ? 'Loading projects...' : 'Assigning...'}
              className="w-full"
            />
          </div>

          <DialogFooter className="gap-3">
            <Button
              variant="outline"
              onClick={() => setSingleAssignDevice(null)}
              disabled={isSingleAssigning}
              className="min-w-[100px] border-[#E2E5EA] text-text-grey hover:bg-page-bg"
            >
              Cancel
            </Button>
            <Button
              onClick={handleSingleAssign}
              disabled={isSingleAssigning || !singleAssignProjectName || singleAssignProjectName === singleAssignDevice?.project?.name}
              className="bg-hero-red hover:bg-hero-red-60 text-white min-w-[100px]"
            >
              {isSingleAssigning ? (
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  Assigning...
                </div>
              ) : (
                singleAssignDevice?.project ? 'Update' : 'Assign'
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Project Assignment Confirmation Dialog */}
      <Dialog open={isProjectAssignDialogOpen} onOpenChange={setIsProjectAssignDialogOpen}>
        <DialogContent className="max-w-2xl p-6">
          <div className="flex items-center gap-3 mb-2">
            <div className="flex-shrink-0 w-10 h-10 bg-[rgba(0,39,63,0.06)] rounded-full flex items-center justify-center">
              <Box className="h-5 w-5 text-blueprint-blue" />
            </div>
            <DialogTitle className="text-[18px] font-semibold text-blueprint-blue leading-tight">
              Confirm Project Assignment
            </DialogTitle>
          </div>
          <DialogDescription className="text-[13px] text-text-grey">
            Please review the project and device details before confirming the assignment.
          </DialogDescription>

          <div className="space-y-3 py-4">
            {/* Project Details */}
            {selectedProjectName && (() => {
              const targetProject = availableProjects.find((p: any) => p.name === selectedProjectName);
              if (!targetProject) return null;

              return (
                <div className="bg-page-bg border border-[#E2E5EA] p-3 rounded-md">
                  <p className="text-[12px] text-heritage-grey mb-2 font-medium">Project details</p>
                  <div className="space-y-1">
                    <p className="text-[13px] text-text-grey flex items-center">
                      <span className="w-1.5 h-1.5 bg-heritage-grey rounded-full mr-2"></span>
                      Project name: <span className="font-medium text-blueprint-blue ml-1">{targetProject.name}</span>
                    </p>
                    {targetProject.projectNumber && (
                      <p className="text-[13px] text-text-grey flex items-center">
                        <span className="w-1.5 h-1.5 bg-heritage-grey rounded-full mr-2"></span>
                        Project number: <span className="font-medium text-blueprint-blue ml-1">{targetProject.projectNumber}</span>
                      </p>
                    )}
                  </div>
                </div>
              );
            })()}

            {/* Selected Devices */}
            <div className="bg-page-bg border border-[#E2E5EA] p-3 rounded-md">
              <p className="text-[12px] text-heritage-grey mb-2 font-medium">
                Selected devices ({selectedDevices.length})
              </p>
              <div className="max-h-60 overflow-y-auto space-y-2">
                {selectedDevices.map((deviceId) => {
                  const device = devicesArray.find((d: Device) => d.id === deviceId);
                  if (!device) return null;

                  return (
                    <div key={deviceId} className="bg-white border border-[#E2E5EA] rounded-md p-2">
                      <div className="flex items-center gap-2">
                        <span className="text-[13px] font-medium text-blueprint-blue">{device.id}</span>
                        {device.name && (
                          <span className="text-[13px] text-text-grey">({device.name})</span>
                        )}
                      </div>
                      <div className="flex items-center gap-4 mt-1">
                        {device.status && (
                          <span className="text-[12px] text-heritage-grey">
                            Status: <span className="font-medium text-text-grey">{device.status}</span>
                          </span>
                        )}
                        {device.type && (
                          <span className="text-[12px] text-heritage-grey">
                            Type: <span className="font-medium text-text-grey">{device.type}</span>
                          </span>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Confirmation Message */}
            <div className="bg-[rgba(230,161,0,0.08)] border border-[rgba(230,161,0,0.2)] rounded-md p-3">
              <div className="flex items-start gap-2">
                <AlertCircle className="h-4 w-4 text-[#B38600] flex-shrink-0 mt-0.5" />
                <p className="text-[13px] text-[#B38600]">
                  Are you sure you want to assign <strong className="font-semibold">{selectedProjectName}</strong> to {selectedDevices.length} device{selectedDevices.length !== 1 ? 's' : ''}?
                </p>
              </div>
            </div>
          </div>

          <DialogFooter className="gap-3">
            <Button
              variant="outline"
              onClick={() => setIsProjectAssignDialogOpen(false)}
              disabled={isProjectAssigning}
              className="min-w-[100px] border-[#E2E5EA] text-text-grey hover:bg-page-bg"
            >
              Cancel
            </Button>
            <Button
              onClick={handleBulkProjectAssign}
              disabled={isProjectAssigning}
              className="bg-hero-red hover:bg-hero-red-60 text-white min-w-[100px]"
            >
              {isProjectAssigning ? (
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  Assigning...
                </div>
              ) : (
                'Confirm Assignment'
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {selectedDevice && isDeviceManagementOpen && <EdgeDeviceManagement
        device={selectedDevice}
        onStatusChange={(status: DeviceStatus) => {
          // TODO: Implement Redux action for status change
        }}
        onReboot={() => {
          // TODO: Implement Redux action for device reboot
        }}
        onFirmwareUpdate={() => {
          // TODO: Implement Redux action for firmware update
        }}
        onClose={() => {
          setSelectedDevice(null)
          setIsDeviceManagementOpen(false)
        }}
        onSettingsClick={() => {
          setIsSettingsModalOpen(true)
        }}
        startAutoRefresh={startAutoRefresh}
        stopAutoRefresh={stopAutoRefresh}
        refetchDevice={manualRefresh}
      />}

      <DeviceSettingsModal
        open={isSettingsModalOpen}
        onOpenChange={setIsSettingsModalOpen}
        devices={devicesArray}
        selectedDevice={selectedDevice}
      />

      <Dialog open={isAcknowledgeAlarmsModalOpen} onOpenChange={setIsAcknowledgeAlarmsModalOpen}>
        <DialogContentWithoutClose className="fixed inset-0 w-screen h-screen max-w-none translate-x-0 translate-y-0 rounded-none flex flex-col overflow-hidden data-[state=open]:slide-in-from-none data-[state=closed]:slide-out-to-none">
          <DialogHeader className="flex flex-row items-center justify-between gap-4 space-y-0 pb-2 shrink-0">
            <div className="flex flex-row items-center gap-4 min-w-0">
              <Button
                type="button"
                variant="outline"
                size="icon"
                className="shrink-0 rounded-lg"
                onClick={() => setIsAcknowledgeAlarmsModalOpen(false)}
                aria-label="Back"
              >
                <ArrowLeft className="h-5 w-5 text-gray-500" />
              </Button>
              <div className="min-w-0">
                <DialogTitle>Acknowledge Alarms</DialogTitle>
                <DialogDescription className="sr-only">Alarms that have not been acknowledged.</DialogDescription>
              </div>
            </div>
          </DialogHeader>
          <div className="flex-1 min-h-0 overflow-y-auto px-4 pb-4">
            {loadingNotAcknowledged ? (
              <div className="py-12 text-center text-muted-foreground">Loading...</div>
            ) : notAcknowledgedEvents.length === 0 ? (
              <div className="py-12 text-center text-muted-foreground">No unacknowledged alarms.</div>
            ) : (
              (() => {
                const showEdgeColumn = notAcknowledgedEvents.some(
                  (row) =>
                    (String(row?.edge_uid ?? '').toLowerCase() !== 'impp' &&
                      String(row?.edge_uid ?? '').toLowerCase() !== 'raptor')
                );
                return (
              <div className="rounded-md border w-full overflow-auto">
                <Table className="w-full min-w-full" containerClassName="w-full overflow-auto">
                  <TableHeader>
                    <TableRow>
                      <TableHead className="text-center">
                        <span className="flex items-center justify-center gap-1.5">
                          <Bell className="h-4 w-4 text-muted-foreground shrink-0" />
                          Alarm
                        </span>
                      </TableHead>
                      {showEdgeColumn && (
                        <TableHead className="text-center">
                          <span className="flex items-center justify-center gap-1.5">
                            <Server className="h-4 w-4 text-muted-foreground shrink-0" />
                            Edge / Device
                          </span>
                        </TableHead>
                      )}
                      <TableHead className="text-center">
                        <span className="flex items-center justify-center gap-1.5">
                          <Layers className="h-4 w-4 text-muted-foreground shrink-0" />
                          Coating Type
                        </span>
                      </TableHead>
                      <TableHead className="text-center">
                        <span className="flex items-center justify-center gap-1.5">
                          <Hash className="h-4 w-4 text-muted-foreground shrink-0" />
                          Alarm ID
                        </span>
                      </TableHead>
                      <TableHead className="text-center">
                        <span className="flex items-center justify-center gap-1.5">
                          <Activity className="h-4 w-4 text-muted-foreground shrink-0" />
                          Event Type
                        </span>
                      </TableHead>
                      <TableHead className="text-center">
                        <span className="flex items-center justify-center gap-1.5">
                          <Box className="h-4 w-4 text-muted-foreground shrink-0" />
                          Active
                        </span>
                      </TableHead>
                      <TableHead className="text-center">
                        <span className="flex items-center justify-center gap-1.5">
                          <Clock className="h-4 w-4 text-muted-foreground shrink-0" />
                          Last Notified
                        </span>
                      </TableHead>
                      <TableHead className="text-center">
                        <span className="flex items-center justify-center gap-1.5">
                          <Calendar className="h-4 w-4 text-muted-foreground shrink-0" />
                          Created
                        </span>
                      </TableHead>
                      <TableHead className="text-center">
                        <span className="flex items-center justify-center gap-1.5">
                          <Settings className="h-4 w-4 text-muted-foreground shrink-0" />
                          Action
                        </span>
                      </TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {notAcknowledgedEvents.map((row, idx) => {
                      const meta = row?.meta as Record<string, unknown> | undefined;
                      const alarmText = meta?.alarm_text ?? row?.alarm_text ?? '—';
                      const edgeUid = row?.edge_uid ?? '';
                      const coatingType = row?.coating_type ?? '—';
                      const alarmId = row?.alarm_id ?? '—';
                      const eventType = row?.event_type ?? '—';
                      const isActive = row?.is_active;
                      const lastNotified = row?.last_notified_at
                        ? formatDateUTC(String(row.last_notified_at))
                        : '—';
                      const createdAt = row?.createdAt
                        ? formatDateUTC(String(row.createdAt))
                        : '—';
                      return (
                        <TableRow key={String(row?.id ?? idx)}>
                          <TableCell className="font-medium">{String(alarmText)}</TableCell>
                          {showEdgeColumn && (
                            <TableCell>{edgeUid ? String(edgeUid) : '—'}</TableCell>
                          )}
                          <TableCell>{String(coatingType)}</TableCell>
                          <TableCell>{String(alarmId)}</TableCell>
                          <TableCell>{String(eventType)}</TableCell>
                          <TableCell>{isActive === true ? 'Yes' : isActive === false ? 'No' : '—'}</TableCell>
                          <TableCell>{lastNotified}</TableCell>
                          <TableCell>{createdAt}</TableCell>
                          <TableCell>
                            <Button
                              size="sm"
                              className="flex items-center gap-1.5 bg-[#e04530] text-white hover:bg-[#e04530]/90"
                              onClick={() => {
                                const eventId = row?.id;
                                if (eventId !== undefined && eventId !== null) {
                                  handleAcknowledgeEvent(typeof eventId === 'number' ? eventId : Number(eventId));
                                }
                              }}
                              disabled={
                                row?.id != null &&
                                acknowledgingEventId === (typeof row.id === 'number' ? row.id : Number(row.id))
                              }
                              aria-label={`Acknowledge ${String(alarmText)}`}
                            >
                              {acknowledgingEventId === Number(row?.id) ? (
                                <>
                                  <RefreshCw className="h-4 w-4 animate-spin" />
                                  Acknowledging...
                                </>
                              ) : (
                                <>
                                  <CheckCircle className="h-4 w-4" />
                                  Acknowledge
                                </>
                              )}
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </div>
                );
              })()
            )}
          </div>
        </DialogContentWithoutClose>
      </Dialog>
    </div>
  );
};

export default DeviceManagement; 